<template>
	<div class="main">
		<mainLeft/>
		<mainRight/>
	</div>
</template>

<script>
	import mainLeft from './mainLeft'
	import mainRight from './mainRight'
	
	export default{
		components:{
			mainLeft,mainRight
		}
	}
	
</script>

<style scoped>
	.main{
		width: 1300px;
		margin: 20px auto;
		overflow: hidden;
	}
</style>
